import {  LoanDtoActionIdEnum, UpdatedLeadDto } from 'client';
import { DATA_LAYER_RESPONSE_KEY } from 'constants/DataLayers';
import { LOAN_ACTIONS } from 'constants/LoanActions';
import {
	RESPONSE_PATH,
	RESPONSE_VIEW_ATENCION_CON_EJECUTIVO_ASYNC,
	RESPONSE_VIEW_ATENCION_CON_EJECUTIVO_LOAN_ASYNC,
	RESPONSE_VIEW_LO_SENTIMOS_LOAN,
} from 'constants/ResponseType';
import { useFormData } from 'hooks/useFormData';
import { useMultiFormView } from 'hooks/useMultiFormView';
import { useHistory } from 'react-router-dom';
import { setHashedEmailInStorage } from 'utils/setHashedEmailInStorage';
import { useLoanServices } from './useLoanServices';
import { useStorage } from './useStorage';

export const useLoanFormContainerControl = (
	knockOutErrorKey: string,
	scoringErrorKey: string,
	scoringResponse?: string
) => {
	const history = useHistory();
	const {
		step,
		setStep,
		enableButton,
		setEnableButton,
		showLoadingModal,
		setShowLoadingModal,
		showLongModal,
		setShowLongModal,
	} = useMultiFormView();
	const LOAN_FORM_KEY = 'LOAN_FORM';
	const { formatFormData, setInitialVariablesForm } = useFormData();
	const { createLoan, updateLoan, createRefinancingLoan } = useLoanServices();
	const { getItemFromStorage, saveInStorage, deleteItemFromStorage, getFromStorage } = useStorage();

	
	const scoringResolver = (response: UpdatedLeadDto) => {
		if (
			response.scoring &&
			response.crmIdentifier &&
			(response.scoring.color === 'Verde' || response.scoring.color === 'Amarillo')
		) {
			let loanDto = JSON.parse(getFromStorage(LOAN_FORM_KEY) || '{}');
			loanDto.trafficSoçurces = '';
			window.location.href = `/simulacion/?isFromLoan=true&${new URLSearchParams({
				...loanDto,
				...response.indexaSimulation,
				crmIdentifier: response.crmIdentifier,
			})}`;
			// history.push(
			// 	`/simulacion/?isFromLoan=true&${new URLSearchParams({
			// 		...loanDto,
			// 		...response.indexaSimulation,
			// 		crmIdentifier: response.crmIdentifier,
			// 	})}`
			// );
		} else {
			history.push(`${RESPONSE_PATH}/${RESPONSE_VIEW_LO_SENTIMOS_LOAN}/${scoringErrorKey}`);
		}
	};

	const saveIdAndVersionInStorage = (response: any) => {
		const { id, version } = response;
		saveInStorage(LOAN_FORM_KEY, { id, version });
	};

	const refinancingResolver = (response: any) => {
		const { state, crmIdentifier } = response;
		saveInStorage('CMR_ID', { crmIdentifier });
		if (state === 'OK') {
			window.location.href = `${RESPONSE_PATH}/${RESPONSE_VIEW_ATENCION_CON_EJECUTIVO_ASYNC}/${DATA_LAYER_RESPONSE_KEY.REFINANCING_SOLICITUD_EXITOSA}`;
			return;
		} else {
			window.location.href = `${RESPONSE_PATH}/${RESPONSE_VIEW_LO_SENTIMOS_LOAN}/${DATA_LAYER_RESPONSE_KEY.REFINANCING_RECHAZO_KO}`;
			return;
		}
	};

	const loanExecuteActions: Record<LOAN_ACTIONS, Function> = {
		[LOAN_ACTIONS.SAVE_FORM_AND_CALL_REFINANCING_SERVICE]: (formData: any) => {
			saveInStorage(LOAN_FORM_KEY, formData);
			let localFormData = JSON.parse(getFromStorage(LOAN_FORM_KEY) || '{}');
			setInitialVariablesForm(localFormData);
			setHashedEmailInStorage(localFormData.email);
			setShowLoadingModal(true);
			createRefinancingLoan({ ...formatFormData(localFormData) }, (response: any) =>
				refinancingResolver(response)
			);
		},
		[LOAN_ACTIONS.BACK_STEP]: (_formData: any) => {
			setStep(step - 1);
		},
		[LOAN_ACTIONS.NEXT_STEP]: (formData: any) => {
			saveInStorage(LOAN_FORM_KEY, formData);
			setStep(step + 1);
		},
		[LOAN_ACTIONS.BACK_TO_HOME]: (_formData: any) => {
			window.location.href = `${process.env.REACT_APP_WORDPRESS_URL} `;
		},
		[LOAN_ACTIONS.RESET_ID_STATUS_AND_BACK_STEP]: (_formData: any) => {
			deleteItemFromStorage(LOAN_FORM_KEY, 'id');
			deleteItemFromStorage(LOAN_FORM_KEY, 'version');
			setStep(step - 1);
		},
		[LOAN_ACTIONS.SAVE_FORM_AND_UPDATE_WITH_KNOCKOUT]: (formData: any) => {
			saveInStorage(LOAN_FORM_KEY, formData);
			setShowLoadingModal(false);
			setInitialVariablesForm(formData);			
			setStep(step + 1);
		},

		[LOAN_ACTIONS.SAVE_FORM_IN_SERVICES]: (formData: any) => {
			saveInStorage(LOAN_FORM_KEY, formData);
			setShowLoadingModal(true);
			setInitialVariablesForm(formData);
			createLoan(formData, (response: any) => {
				saveIdAndVersionInStorage(response);
				setShowLoadingModal(false);
				setStep(step + 1);
			});
		},
		[LOAN_ACTIONS.SAVE_FORM_IN_STORAGE]: (formData: any) => {
			saveInStorage(LOAN_FORM_KEY, formData);
		},
		[LOAN_ACTIONS.UPDATE_FORM]: (formData: any) => {
			saveInStorage(LOAN_FORM_KEY, formData);
			setShowLoadingModal(true);
			updateLoan(
				{
					...formatFormData(formData),
					actionId: null,
					version: getItemFromStorage(LOAN_FORM_KEY, 'version'),
				},
				getItemFromStorage(LOAN_FORM_KEY, 'id'),
				(response: any) => {
					saveIdAndVersionInStorage(response);
					setShowLoadingModal(false);
					setStep(step + 1);
				}
			);
		},
		[LOAN_ACTIONS.UPDATE_FORM_WITH_KNOCKOUT]: (formData: any) => {
			saveInStorage(LOAN_FORM_KEY, formData);
			setShowLoadingModal(true);
			setStep(step + 1);
			
		},
		[LOAN_ACTIONS.UPDATE_FORM_WITH_SCORING_AND_FINISH]: (formData: any) => {
			let preFormData =   JSON.parse(getFromStorage(LOAN_FORM_KEY) || '{}');		
			saveInStorage(LOAN_FORM_KEY, formData);		
			setInitialVariablesForm(formData);
			formData.firstName = preFormData.firstName;
			formData.lastName = preFormData.lastName;
			formData.nationalId = preFormData.nationalId;
			formData.dateOfEmployment = preFormData.dateOfEmployment;
			formData.email = preFormData.email;
			formData.phone = preFormData.phone;
			formData.touchPointSelected = preFormData.touchPointSelected;
			//formData.email = preFormData.email;	
			formData.version = preFormData.version;		
			formData.salary = preFormData.salary;	
			
			setShowLoadingModal(true);			
			createLoan(
				{ ...formatFormData(formData), 
					actionId:LoanDtoActionIdEnum.AsyncScoringAndFinish
				},
				(response: any) => {
					saveIdAndVersionInStorage(response);
					setShowLoadingModal(false);
					history.push(
						`${RESPONSE_PATH}/${RESPONSE_VIEW_ATENCION_CON_EJECUTIVO_LOAN_ASYNC}/${scoringResponse}`
					);
					
				});

		},
		[LOAN_ACTIONS.UPDATE_FORM_WITH_SCORING_SYNC_AND_FINISH]: async (formData: any) => {
			saveInStorage(LOAN_FORM_KEY, formData);
			setShowLoadingModal(true);
			setShowLongModal(true);
			updateLoan(
				{
					...formatFormData(formData),
					actionId: LoanDtoActionIdEnum.ScoringAndFinish,
					version: getItemFromStorage(LOAN_FORM_KEY, 'version'),
				},
				getItemFromStorage(LOAN_FORM_KEY, 'id'),
				(response: any) => {
					saveInStorage('CMR_ID', { crmIdentifier: response.crmIdentifier });
					saveIdAndVersionInStorage(response);
					scoringResolver(response);
				}
			);
		},
	};

	const executeAction = (action: LOAN_ACTIONS, formData: any) => {
		loanExecuteActions[action](formData);
	};

	return {
		executeAction,
		step,
		enableButton,
		setEnableButton,
		showLoadingModal,
		setShowLoadingModal,
		showLongModal,
	} as const;
};
